// @flow

import React, { Component } from 'react';
import styler from 'react-styling';
import getLanguage from '../libs/Languages';
import { logError } from '../libs/Logger';
import { SignupStatusPage } from '../Components/index';

const style = styler `
  Container
    background-color: #FFF
    width: 100%
    height: 100%
    font-size: 22px
    position: fixed
    top: 0
    left: 0
    z-index: 1000
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    text-align: center
`;

const pollFrequency = 15000;
const lang = getLanguage();

class SignupStatusContainer extends Component {

  state = {
    signupReady: false,
  };

  state: {
    signupReady: bool,
  };

  componentDidMount() {
    this._statusPoller = this._statusPoll();
  }

  componentWillUnmount() {
    clearInterval(this._statusPoller);
  }

  _statusPoller: number;

  _statusPoll = () => (
    setInterval(() => {
      try {
        this._getStatus().then(() => {
          this.setState({
            signupReady: true,
          });
        });
      } catch (error) {
        logError(error);
      }
    }, pollFrequency)
  );

  _getStatus = async () => {
    const response = await fetch('signupStatus', {
      credentials: 'include',
    });

    if (response.ok) return await response.json();
    throw new Error(response.status);
  }

  render() {
    const { signupReady } = this.state;
    return (
      <div style={style.Container}>
        <div>
          {
            signupReady ? (
              <SignupStatusPage lang={lang} status="ready" />
            ) : (
              <SignupStatusPage lang={lang} status="pending" />
            )
          }
        </div>
      </div>
    );
  }

}

export default SignupStatusContainer;



// WEBPACK FOOTER //
// ./src/js/Containers/SignupStatusContainer.js